module.exports = __webpack_public_path__ + "img/guideE.c3a21d4c.png";